import { Box, styled } from '@mui/material';

import { sharedRichTextStyles } from 'components/UIkit/atoms/RichText/RichText.styles';

export const StyledHtmlContentContainer = styled(Box)(({ theme }) => sharedRichTextStyles(theme));

export const StyledInlineHtmlContentContainer = styled('span')(({ theme }) =>
  sharedRichTextStyles(theme)
);
